import { BO_URL } from 'constants/Global';

import type { MayBe } from 'types/common';
import type { CustomImage } from './types';

export const formatMessageForAllLanguages = (message: string, languages: Array<string> = []): Record<string, string> => {
  if (message) {
    return languages.reduce<Record<string, string>>(
      (acc, lang) => ({
        ...acc,
        [lang]: message,
      }),
      {}
    );
  }
  return {};
};

export const formatImageIdForAllLanguages = (
  language: string,
  custom: CustomImage = {},
  languages: Array<string> = []
): Record<string, MayBe<string>> => {
  if (custom) {
    const customLangs = Object.keys(custom);
    const image = custom[language] || custom[customLangs[0]];
    return languages.reduce<Record<string, MayBe<string>>>(
      (acc, lang) => ({
        ...acc,
        [lang]: image?.id,
      }),
      {}
    );
  }
  return {};
};

export const formatCustomImages = (custom: CustomImage = {}): Record<string, MayBe<string>> =>
  Object.entries(custom).reduce<Record<string, MayBe<string>>>((acc, [key, value]) => {
    if (value?.id) {
      acc[key] = value.id;
    }
    return acc;
  }, {});

export const setImageCustom = (origin: { [language: string]: string } = {}): CustomImage => {
  const custom: CustomImage = {};
  Object.entries(origin).forEach(([key, value]) => {
    custom[key] = { id: value, image: value };
  });
  return custom;
};

export const redirectToBO = (dealerId: string) => {
  const redirectUrl = dealerId
    ? `${BO_URL}/dealer/config/${dealerId}/customisation#customisation.templates`
    : `${BO_URL}/group/management/templates`;
  window.location.assign(redirectUrl);
};
